import type {FieldView} from '@src/api/field/api.d';
import {FIELD_TYPES} from '@api/constants';
import {getHasFieldValidationError} from './getFieldValidationErrorKey';

const BOOLEAN_FIELD_TYPES: string[] = [FIELD_TYPES.CHECKBOX, FIELD_TYPES.RADIO];

export function getIsFieldFilled(field: FieldView): boolean {
    if (!field.value || getHasFieldValidationError(field)) {
        return false;
    }

    const fieldType = field.type?.toLowerCase();
    if (fieldType && BOOLEAN_FIELD_TYPES.includes(fieldType)) {
        return field.value === 'true';
    }

    return true;
}
